import React from 'react';
import PropTypes from 'prop-types';
import Logo from '../images/logo-alt.svg';
import './header.scss';

const LandingHeaderLinks = () => (
  <ul>
    <li className="c-nav__link">
      <a href="/#products">Products</a>
    </li>
    <li className="c-nav__link">
      <a href="/about">About</a>
    </li>
    <li className="c-nav__link">
      <a href="mailto:help@gotok.app">Contact</a>
    </li>
  </ul>
);

export default function Header({ children }) {
  return (
    <header className="c-header">
      <div className="l-wrapper">
        <div className="l-row">
          <nav className="c-nav">
            <div className="c-nav__logo">
              <a href="/">
                <img src={Logo} alt="Gotok" />
              </a>
            </div>

            <menu className="c-nav__menu">{children}</menu>
          </nav>
        </div>
      </div>
    </header>
  );
}

Header.propTypes = {
  children: PropTypes.node.isRequired,
};

export { LandingHeaderLinks };
